'use client';

import * as React from 'react';
import { mergeProps } from '../../merge-props/index.js';
export function useToolbarRoot(parameters) {
  const {
    orientation
  } = parameters;
  const [itemMap, setItemMap] = React.useState(() => new Map());
  const disabledIndices = React.useMemo(() => {
    const output = [];
    for (const itemMetadata of itemMap.values()) {
      if (itemMetadata?.index && !itemMetadata.focusableWhenDisabled) {
        output.push(itemMetadata.index);
      }
    }
    return output;
  }, [itemMap]);
  const getRootProps = React.useCallback((externalProps = {}) => {
    return mergeProps({
      'aria-orientation': orientation,
      role: 'toolbar'
    }, externalProps);
  }, [orientation]);
  return React.useMemo(() => ({
    getRootProps,
    disabledIndices,
    setItemMap
  }), [getRootProps, disabledIndices, setItemMap]);
}